export default {
    // Modal/Layer
    modal: {
        logout: {
            title: 'Đăng xuất',
            message: 'Bạn có muốn đăng xuất không?',
        },
        confirm: {
            title: 'Xác nhận',
            message: 'Bạn có chắc chắn muốn tiếp tục không?',
        },
    },

    // Dropdown/Select
    dropdown: {
        selectOption: 'Vui lòng chọn một tùy chọn',
        noOptions: 'Không có tùy chọn nào',
    },

    // Bảng
    table: {
        headers: {
            item: 'Mục',
            content: 'Nội dung',
            activity: 'Hoạt động',
            mode: 'Chế độ',
            result: 'Kết quả',
            time: 'Thời gian',
            student: 'Học sinh',
            answer: 'Câu trả lời',
            score: 'Điểm',
            status: 'Trạng thái',
        },
        noData: 'Không có dữ liệu',
        loading: 'Đang tải...',
    },

    // Biểu mẫu
    form: {
        required: 'Trường bắt buộc',
        invalid: 'Định dạng không hợp lệ',
        saved: 'Đã lưu',
        errors: {
            network: 'Đã xảy ra lỗi mạng',
            validation: 'Vui lòng kiểm tra lại thông tin nhập',
            server: 'Đã xảy ra lỗi máy chủ',
        },
    },

    // Tải/Trạng thái
    loading: {
        default: 'Đang tải...',
        saving: 'Đang lưu...',
        processing: 'Đang xử lý...',
        connecting: 'Đang kết nối...',
    },

    // Thông báo/Toast
    toast: {
        success: 'Đã hoàn thành thành công',
        error: 'Đã xảy ra lỗi',
        warning: 'Cần chú ý',
        info: 'Vui lòng kiểm tra thông tin',
    },
};
